<template>
  <div class="user-wrapper">
    <div class="content-box">
        <v-select-lang/>
      <!-- <a href="https://pro.loacg.com/docs/getting-started" target="_blank">
        <span class="action">
          <a-icon type="question-circle-o"></a-icon>
        </span>
      </a> -->
      <!-- <notice-icon class="action"/> -->
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar"/>
          <span>{{ nickname }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <!-- <a-menu-item key="0">
            <router-link :to="{ name: 'center' }">
              <a-icon type="user"/>
              <span>个人中心</span>
            </router-link>
          </a-menu-item> -->
          <a-menu-item key="1">
            <div @click="handleModify">
              <a-icon type="setting"/>
              <span> {{ $t('home.modifyPassword') }}</span>
            </div>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="2">
            <div @click="googleAuthModify">
              <a-icon type="setting"/>
              <span> GoogleAuth</span>
            </div>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="3">
            <div @click="handleLogout">
              <a-icon type="logout"/>
              <span> {{ $t('signOut') }}</span>
            </div>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <a-modal
        v-model="visible"
        :maskClosable="false"
        :confirmLoading="confirmLoading"
        :title="$t('home.modifyPassword')"
        @ok="submitPassword"
        @cancel="handleClosePassword"
    >
        <a-form :form="basicForm">
            <a-form-item :label="$t('oldPassword')" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-input
                v-decorator="['oldPassword', validator.oldPassword]"
                type="password"
              />
            </a-form-item>
            <a-form-item :label="$t('newPassword')" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-input
                v-decorator="['password', validator.password]"
                type="password"
              />
            </a-form-item>
            <a-form-item :label="$t('confirmPassword')" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-input
                v-decorator="['confirmPassword', validator.confirmPassword]"
                type="password"
              />
            </a-form-item>
        </a-form>
    </a-modal>

    <a-modal
      v-model="googleAuthVisible"
      :maskClosable="false"
      :confirmLoading="googleAuthLoading"
      :title="$t('googleAuthBind')"
      @ok="submitGooleAuth"
      @cancel="handleClosePassword"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <p>请扫描二维码或使用密钥进行绑定</p>
        <img :src="codeImgSrc" alt="" />
        <p class="keyMsg">密钥：{{ keyMsg }}</p>
        <div class="codeinput">
          <a-input  v-model="tokenValue" placeholder="请输入令牌" />
        </div>
      </div>
    </a-modal>

    <a-modal
      v-model="openDeleteGoogle"
      :maskClosable="false"
      :confirmLoading="googleAuthDeleteLoading"
      :title="$t('googleAuthUnbind')"
      @ok="deleteGoogle"
      @cancel="handleClosePassword"
    >
      <p>
        请输入GoogleAuth令牌进行解绑
      </p>
      <a-input v-model="deleteTokenValue" placeholder="请输入令牌" />
    </a-modal>


  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import vSelectLang from './LangSelect';
import { mapActions, mapGetters } from 'vuex'
import { deleteGoogleAuth, getGoogleAuth, getGoogleAuthMsg, putGoogleAuthMsg } from '../../api/login'


export default {
    name: 'UserMenu',
    components: {
        NoticeIcon,
        vSelectLang,
    },
    data () {
        return {
            openCode: false, // 是否打开googleAuth绑定弹窗
            codeImgSrc: '', // googleAuth二维码
            keyMsg: '', // googleAuth密钥
            tokenValue: '', // googleAuth令牌
            deleteTokenValue: '', // 解除绑定googleAuth令牌
            openDeleteGoogle: false, // 解除绑定googleAuth弹窗
            defaultLanguage: ['zh-CN'],
            confirmLoading: false,
            googleAuthLoading: false,
            googleAuthDeleteLoading: false,
            visible: false,
            googleAuthVisible: false,
            basicForm: this.$form.createForm(this),
            validator: {
              oldPassword: {
                validateTrigger: 'blur',
                rules: [
                  { required: true, message: this.$t('enter') + ' ' + this.$t('oldPassword') }
                ]
              },
              password: {
                validateTrigger: 'blur',
                rules: [
                  { required: true, message: this.$t('enter') + ' ' + this.$t('password') }
                ]
              },
              confirmPassword: {
                validateTrigger: 'blur',
                rules: [
                  { required: true, message: this.$t('enter') + ' ' + this.$t('confirmPassword') },
                  {
                    validator: (rule, value, callback) => {
                        const form = this.basicForm;
                        if (value && value !== form.getFieldValue('password')) {
                            callback(this.languageStorage == 'en-US' ? 'Two passwords that you enter is inconsistent!': '两次密码不能相同');
                        } else {
                            callback();
                        }
                    },
                  },
                ]
              },
            },
        }
    },
    computed: {
        ...mapGetters(['nickname', 'avatar']),
        ...mapGetters('language', ['languageStorage']),
    },
    watch: {
    },
    mounted () {
      this.getUserId()
    },
    methods: {
        ...mapActions(['Logout', 'LogoutV1', 'modifyPassword']),
      getUserId () {
        getGoogleAuth().then(googleres => {
          if (googleres.data.googleAuthState !== 1) {
            this.getGoogleMsg()
            this.openCode = true
          } else {
            this.openCode = false
          }
        })
      },
      // 查询GoogleAuth信息
      getGoogleMsg () {
        getGoogleAuthMsg().then(res => {
          this.codeImgSrc = res.data.otpAuthURL
          this.keyMsg = res.data.secret
        })
      },
      submitGooleAuth () {
        this.googleAuthLoading = true
        putGoogleAuthMsg({ code: this.tokenValue }).then(res => {
          if (res.code === 1000) {
            this.googleAuthLoading = false
            this.$message.success('绑定成功')
            this.tokenValue = ''
            this.getUserId()
            this.googleAuthVisible = false
          }else {
            this.googleAuthLoading = false
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.googleAuthLoading = false
          this.$message.error('绑定失败')
        })

      },
      // 解除绑定GoogleAuth
      deleteGoogle () {
        this.googleAuthDeleteLoading = true
        if (this.deleteTokenValue === '') {
          this.$message.error('请输入令牌')
          return
        }
        const data = {
          code: this.deleteTokenValue
        }
        deleteGoogleAuth(data).then(res => {
          if (res.code === 1000) {
            this.$message.success('解除绑定成功')
            this.getUserId()
            this.deleteTokenValue = ''
            this.googleAuthDeleteLoading = false
            this.openDeleteGoogle = false
          }else{
            this.$message.error(res.msg)
            this.googleAuthDeleteLoading = false
          }
        })
      },
        handleLogout () {
            this.$confirm({
                title: this.$t('tips'),
                content: this.$t('home.signOutInfo'),
                onOk: () => {
                return this.Logout({}).then(() => {
                  this.$router.push(`/user/login`)
                }).catch(err => {
                    this.$message.error({
                        title: this.$t('error'),
                        description: err.message
                    })
                })
            },
                onCancel () {
                }
            })
        },
        handleModify () {
          this.visible = true;
        },
        googleAuthModify () {
          if(this.openCode){
            this.googleAuthVisible = true;
          }else{
            this.openDeleteGoogle = true;
          }
        },
        handleClosePassword () {
          this.basicForm.resetFields();
        },
        submitPassword () {
          // 触发表单验证
          this.basicForm.validateFields((err, values) => {
            if (!err) {
              this.confirmLoading = true;
              this.modifyPassword(values).then(res => {
                this.$message.success(this.$t('success'))
                console.log("---------->1")
                this.visible = false;
                console.log("---------->2")

                this.LogoutV1({}).then(() => {
                  this.$router.push(`/user/login`)
                }).catch(err => {
                  this.$message.error({
                    title: this.$t('error'),
                    description: err.message
                  })
                })
              }).catch(e => {
                this.$message.error(e.message);
                this.visible = false;
              }).finally(() => {
                this.confirmLoading = false;
                this.handleClosePassword();
              })
            }
          })
        },
    }
}
</script>

<style lang="less" scoped>
.keyMsg {
  margin-top: 10px;
  word-break: break-all;
  font-size: 14px;
  color: #747373;
}
.codeinput{
  width: 300px;
  margin: 20px auto;
}
.btnBox{
  width: 600px;
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
}
</style>
